import React, { useEffect, useState } from "react";
import {
  useAthleteProfile,
  useAthleteStats,
} from "../../api/athleteprofile/queryHooks";
import { useParams } from "react-router-dom";
import useAthleteprofileStore from "./store/AthleteprofileStore";
import { decodeId } from "../../api/utils";

const FieldTabs = () => {
  const currentTournamentsTab = useAthleteprofileStore(
    (state) => state.currentTournamentsTab
  );
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useAthleteStats(id);

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const setCurrentStatsData = useAthleteprofileStore(
    (state) => state.setCurrentStatsData
  );

  useEffect(() => {
    if (data?.data) {
      const selectedTabData = data.data.find(
        (item) => item.play_formats === currentTournamentsTab?.name
      );
      const tboptions = selectedTabData?.stats_data.map((item) => ({
        id: item.id,
        name: item.play_style,
        stats_data: item.player_stats,
      }));
      setOptions(tboptions || []);
      setCurrentStatsData(tboptions?.[0]);
      setSelectedOption(tboptions?.[0]);
    }
  }, [data, currentTournamentsTab, setCurrentStatsData]);

  if (isLoading || options?.length === 0) return null;

  return (
    <div className="flex items-center justify-center mb-3">
      <div className="flex items-center text-xs text-[#666666] flex-nowrap overflow-x-auto hide-scrollbar">
        {options.map((item) => (
          <button
            key={item.id}
            className={`border-r border-r-[#666666] last:border-r-0 px-2 flex-shrink-0 ${
              selectedOption?.id === item.id ? "text-white" : ""
            }`}
            onClick={() => {
              setSelectedOption(item);
              setCurrentStatsData(item);
            }}
          >
            {item.name}
          </button>
        ))}
      </div>
    </div>
  );
};

const ScoreBoard = () => {
  const currentStatsData = useAthleteprofileStore(
    (state) => state.currentStatsData
  );

  const data = Object.entries(currentStatsData?.stats_data || {}).map(
    ([key, value], index) => ({
      id: index,
      title: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()),
      value: value,
    })
  );

  if (currentStatsData === null) return null;

  return (
    <div className="flex justify-center items-center my-3 gap-[10px] flex-wrap">
      {data.map((item) =>
        item.value ? (
          <div
            key={item.id}
            className="px-2 py-1 rounded-lg text-center bg-[#333333] min-w-[72px]"
          >
            <p className="text-xs">{item.value}</p>
            <p className="text-[10px]">{item.title}</p>
          </div>
        ) : (
          <React.Fragment key={item.id}></React.Fragment>
        )
      )}
    </div>
  );
};

const TournamentsTabs = () => {
  const [options, setOptions] = useState(null);

  const selectedOption = useAthleteprofileStore(
    (state) => state.currentTournamentsTab
  );
  const setSelectedOption = useAthleteprofileStore(
    (state) => state.setCurrentTournamentsTab
  );

  const id = decodeId(useParams()?.id);
  const { data } = useAthleteStats(id, {
    onSuccess: (data) => {
      const fetched_options = data.data.map((item, index) => ({
        id: index,
        name: item.play_formats,
      }));
      setOptions(fetched_options);
      setSelectedOption(fetched_options[0]);
    },
  });

  if (options === null || data?.data?.length === 0) return null;
  return (
    <div className="relative">
      <div className="absolute bottom-0 left-0 w-full border-b-2 border-[#2C2D36]"></div>
      <div className="px-5 mt-4 text-[#666666] flex items-center gap-3 text-xs flex-nowrap overflow-x-auto hide-scrollbar">
        {options.map((option) => (
          <button
            key={option.id}
            className={`px-2 pb-2 flex-shrink-0 border-b-2 relative ${
              selectedOption?.id === option.id
                ? "border-[#FE0677] text-white"
                : "border-transparent"
            } `}
            onClick={() => setSelectedOption(option)}
          >
            {option.name}
          </button>
        ))}
      </div>
    </div>
  );
};

const ProfileDescription = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading, isError } = useAthleteProfile(id);

  if (isError) return null;

  return (
    <div className="px-5">
      <p className="text-xs">
        {isLoading ? (
          ""
        ) : (
          <>
            {data.data.bio_description.slice(100)}
            {data.data.bio_description.length > 100 ? (
              <span className="text-[#666666]">… more</span>
            ) : null}
          </>
        )}
      </p>
    </div>
  );
};

const ScoreTabContainer = () => {
  return (
    <>
      <div className="flex flex-col mt-2">
        <ProfileDescription />
        <div className="flex-grow">
          <TournamentsTabs />
          <ScoreBoard />
          <FieldTabs />
        </div>
      </div>
      <div className="mb-3 border-b-2 border-[#2C2D36]"></div>
    </>
  );
};

export default ScoreTabContainer;
